import { Component, OnInit } from '@angular/core';
import {
	AuthService,
	InvoiceService,
	StaticTextService,
	ConfigService,
} from '../../services';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { ErrorDialogComponent } from '../../dialog/error-dialog/error-dialog.component';
import { CONSTANTS } from '../../app.constants';
import * as momentTimeZone from 'moment-timezone';
import { MatDialog } from '@angular/material/dialog';
import { InvoiceServiceV2 } from './invoice.service';
import { SelectionModel } from '@angular/cdk/collections';
import { Title } from '@angular/platform-browser';
import { InvoiceDetailsComponent } from './invoice-details/invoice-details.component';

const INVOICE_STATES = {
	PAST_DUE: 'Past Due',
	CURRENT_DUE: 'Current Due',
	NOT_DUE: 'Not Due Yet',
};

@Component({
	selector: 'app-invoice_v2',
	templateUrl: './invoice.component.html',
	styleUrls: ['./invoice.component.scss'],
})
export class InvoiceComponentV2 implements OnInit {
	filterBy = {
		Customer_ID: null,
		Organization_ID: null,
		fromDate: null,
		toDate: null,
	};
	errors = {
		Date_Range: null,
		date: null,
	};
	orders = [];
	invoices = [];
	pastDueInvoices = [];
	currentDueInvoices = [];
	notDueInvoices = [];
	clickedRows = new Set();
	tableColumns = ['select', 'invoiceDate', 'dueDate', 'billTo', 'total', 'status'];
	creatingCheckoutSession = false;
	selection: any;
	address = '';
	total = 0;
	availabledates = [];
	pdfFilter: any = {};
	selectedPeriod: any;
	maxFromDate: Date;
	maxToDate: Date;
	clientAddress: any = {};
	timer: any;
	sortEvent: any = null;

	constructor(
		private auth: AuthService,
		private invoiceService: InvoiceService,
		private invoiceServiceV2: InvoiceServiceV2,
		public text: StaticTextService,
		private router: Router,
		private matDialog: MatDialog,
		private config: ConfigService,
		private titleService: Title,
	) {}

	ngOnInit() {
		this.titleService.setTitle(`Pippin Title™ - Client - Invoices`);
		this.auth.getHubSpotTokenDetails();
		this.auth.loadHubSpotChatToken();
		this.filterBy.Customer_ID = this.auth.getUserId();
		this.filterBy.Organization_ID = this.auth.orgId;
		this.getClientAddress();
		this.getCompletedOrderSpan();
		this.getDueInvoicesData();
		this.selection = new SelectionModel<any>(true, []);
		this.timer = setTimeout(() => this.config.setSideBarNode(6), 0);
	}

	ngOnDestroy() {
		if (this.timer) clearTimeout(this.timer);
	}

	isAllSelected() {
		const numSelected = this.selection.selected.length;
		const numRows = this.invoices.filter(e => e.status !== 'Paid').length;
		return numSelected == numRows;
	}

	toggleAllRows() {
		this.isAllSelected()
			? this.selection.clear()
			: this.invoices.forEach(
					invoice => invoice.status !== 'Paid' && this.selection.select(invoice),
			  );
	}

	handlePaySelectedInvoices() {
		this.creatingCheckoutSession = true;
		const selected = this.selection.selected;
		this.invoiceServiceV2.paySelectedInvoices(selected).subscribe(({ url }) => {
			this.creatingCheckoutSession = false;
			window.location.href = url;
		});
	}

	openOrderDetailsModal(invoice: any) {
		const dialogRef = this.matDialog.open(InvoiceDetailsComponent, {
			width: '800px',
			maxWidth: '90vw',
			maxHeight: '90vh',
			data: invoice,
			panelClass: 'order-details-dialog',
		});
	}

	isDownloadDisabled(): boolean {
		const disabledPeriods = [
			INVOICE_STATES.PAST_DUE,
			INVOICE_STATES.CURRENT_DUE,
			INVOICE_STATES.NOT_DUE,
		];

		return disabledPeriods.includes(this.selectedPeriod);
	}

	validateDateRange() {
		if (
			this.filterBy.fromDate &&
			this.filterBy.toDate &&
			this.filterBy.fromDate > this.filterBy.toDate
		) {
			return false;
		} else {
			return true;
		}
	}

	setEvalperiod(event) {
		this.orders = [];

		if (event != -1 && event.year && event.month) {
			const { start, end } = this.getStartAndEndOfMonth(event.year, event.month);
			this.filterBy.fromDate = start;
			this.filterBy.toDate = end;
			this.getInvoiceOrdersV2();
			return;
		}
		this.selectedPeriod = event;
		if (event === INVOICE_STATES.PAST_DUE) {
			this.getPastDueInvoicesData(true);
		}

		if (event === INVOICE_STATES.CURRENT_DUE) {
			this.getCurrentDueInvoicesData(true);
		}

		if (event === INVOICE_STATES.NOT_DUE) {
			this.getNotDueYetInvoicesData(true);
		}
	}

	getlastComplMonth() {
		let last = moment().subtract(0, 'months');
		return {
			moment: last,
			month: last.format('MMMM'),
			year: last.year(),
		};
	}

	validateDateFn(event) {
		let formattedDate = moment(event).format('L');
		let DATE_REGEXP = /^(0?[1-9]|1[012])\/(0?[1-9]|[12][0-9]|3[01])\/[12][0-9]{3}$/; //for m/d/yyyy and mm/dd/yyyy
		if (formattedDate && !DATE_REGEXP.test(formattedDate)) this.errors['date'] = true;
		else delete this.errors['date'];
	}

	getInvoiceOrdersV2() {
		if (!this.validateDateRange()) {
			this.errors.Date_Range = true;
			this.orders = [];
		} else {
			delete this.errors.Date_Range;
			if (this.filterBy.fromDate && this.filterBy.toDate && !this.errors.date) {
				this.pdfFilter = Object.assign({}, this.filterBy);
				this.invoiceServiceV2.getInvoiceOrders(this.filterBy).subscribe(res => {
					this.invoices = res;
				});
			}
		}
	}

	getPastDueInvoicesData(overrideTableInvoices = false) {
		return this.invoiceServiceV2.getPastDueInvoices(this.filterBy).subscribe(pastDue => {
			this.pastDueInvoices = pastDue;
			if (overrideTableInvoices) {
				this.invoices = pastDue;
			}
		});
	}

	getCurrentDueInvoicesData(overrideTableInvoices = false) {
		return this.invoiceServiceV2
			.getCurrentDueInvoices(this.filterBy)
			.subscribe(currDue => {
				this.currentDueInvoices = currDue;
				if (overrideTableInvoices) {
					this.invoices = currDue;
				}
			});
	}

	getNotDueYetInvoicesData(overrideTableInvoices = false) {
		this.invoiceServiceV2.getNotDueInvoices(this.filterBy).subscribe(notDue => {
			this.notDueInvoices = notDue;
			if (overrideTableInvoices) {
				this.invoices = notDue;
			}
		});
	}

	getInvoicesTotal(): number {
		return this.invoices.reduce((sum, invoice) => {
			return sum + (parseFloat(invoice.total) || 0);
		}, 0);
	}

	private formatDateToMDY(dateString: string): string {
		const date = new Date(dateString);
		if (isNaN(date.getTime())) {
			return dateString;
		}
		const month = date.getMonth() + 1;
		const day = date.getDate();
		const year = date.getFullYear();
		return `${month}/${day}/${year}`;
	}

	downloadInvoicesAsCSV(): void {
		if (this.invoices.length === 0) {
			return;
		}

		const headers = [
			'Invoice Date',
			'Due Date',
			'Bill To',
			'Product Description',
			'Amount',
			'Status',
		];
		let csvContent = headers.join(',') + '\n';
		let totalAmount = 0;

		this.invoices.forEach(invoice => {
			const validProducts =
				invoice.Order_Products?.filter(product => product.Order_Product_Price > 0) || [];

			if (validProducts.length === 0) {
				const row = [
					`"${this.formatDateToMDY(invoice.invoiceDate)}"`,
					`"${this.formatDateToMDY(invoice.dueDate)}"`,
					`"${invoice.billTo}"`,
					`"${invoice.productDescription || 'N/A'}"`,
					parseFloat(invoice.total) || 0,
					`"${invoice.status}"`,
				];
				csvContent += row.join(',') + '\n';
				totalAmount += parseFloat(invoice.total) || 0;
			} else {
				validProducts.forEach(product => {
					const row = [
						`"${this.formatDateToMDY(invoice.invoiceDate)}"`,
						`"${this.formatDateToMDY(invoice.dueDate)}"`,
						`"${invoice.billTo}"`,
						`"${product.Product_Description}"`,
						parseFloat(product.Order_Product_Price) || 0,
						`"${invoice.status}"`,
					];
					csvContent += row.join(',') + '\n';
					totalAmount += parseFloat(product.Order_Product_Price) || 0;
				});

				if (invoice.Order_Custom_Price_Tax && invoice.Order_Custom_Price_Tax > 0) {
					const taxRow = [
						`"${this.formatDateToMDY(invoice.invoiceDate)}"`,
						`"${this.formatDateToMDY(invoice.dueDate)}"`,
						`"${invoice.billTo}"`,
						`"Tax"`,
						parseFloat(invoice.Order_Custom_Price_Tax) || 0,
						`"${invoice.status}"`,
					];
					csvContent += taxRow.join(',') + '\n';
					totalAmount += parseFloat(invoice.Order_Custom_Price_Tax) || 0;
				}
			}
		});

		csvContent += `"","","","TOTAL:",${totalAmount.toFixed(2)},""\n`;

		const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
		const link = document.createElement('a');
		const currentDate = new Date().toISOString().split('T')[0];
		const filename = `invoices_${currentDate}.csv`;

		link.href = URL.createObjectURL(blob);
		link.download = filename;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}

	getDueInvoicesData() {
		this.getPastDueInvoicesData();
		this.getCurrentDueInvoicesData();
		this.getNotDueYetInvoicesData();
	}

	getClientAddress() {
		this.auth.getProfile().subscribe(
			data => {
				this.clientAddress = data;
				this.buildAddress(data);
			},
			err => {
				this.openErrorPopup(CONSTANTS.apiErrors.datafetch);
				this.auth.logout();
				this.router.navigate(['/login']);
			},
		);
	}

	buildAddress(model) {
		this.address = '';
		if (model.Address_1) this.address += model.Address_1;
		if (model.Address_2) {
			if (this.address) this.address += ' ';
			this.address += model.Address_2;
		}
		if (model.Address_City) {
			if (this.address) this.address += ', ';
			this.address += model.Address_City;
		}
		if (model.Address_State_Abbr) {
			if (this.address) this.address += ', ';
			this.address += model.Address_State_Abbr;
		}
		if (model.Address_ZipCode) {
			if (this.address) this.address += ' ';
			this.address += model.Address_ZipCode;
		}
	}

	calculateTotal(orders) {
		this.total = 0;
		orders.forEach(order => {
			this.total += Number(order.Order_Custom_Price);
			this.total += Number(order.Order_Custom_Price_Tax);
		});
	}

	openErrorPopup(msg) {
		let dialogRef = this.matDialog.open(ErrorDialogComponent, {
			data: {
				message: msg,
			},
		});
	}

	getCompletedOrderSpan() {
		this.invoiceService.getInvoiceSpan().subscribe(res => {
			this.generateDateSpan(res, this.getlastComplMonth());
		});
	}

	generateDateSpan(start, end) {
		if (start) {
			let startMoment = moment(start);
			let endMoment = end.moment;

			while (endMoment.isSameOrAfter(startMoment, 'month')) {
				this.availabledates.push({
					moment: endMoment,
					month: endMoment.format('MMMM'),
					year: endMoment.year(),
					displayText: `${endMoment.format('MMMM')} ${endMoment.year()}`,
				});
				endMoment.subtract(1, 'month');
			}
			if (!this.availabledates.length) this.availabledates.push(end);
		} else this.availabledates.push(end);
		this.selectedPeriod = this.availabledates[0];
		this.filterBy.fromDate = moment()
			.year(this.selectedPeriod.year)
			.month(this.selectedPeriod.month)
			.startOf('month')
			.toDate();
		this.filterBy.toDate = moment()
			.year(this.selectedPeriod.year)
			.month(this.selectedPeriod.month)
			.endOf('month')
			.toDate();
		this.getInvoiceOrdersV2();
	}

	savePDF() {
		this.invoiceService.generatePDF(this.pdfFilter).subscribe({
			next: (pdfBlob: Blob) => {
				const errorMessage = 'An error occurred downloading the invoice.';
				if (pdfBlob.size === 0) {
					this.openErrorPopup(errorMessage);
					return;
				}

				if (!pdfBlob.type.includes('pdf') && !pdfBlob.type.includes('octet-stream')) {
					this.openErrorPopup(errorMessage);
					return;
				}

				this.verifyPdfBlob(pdfBlob).then(isValid => {
					if (!isValid) {
						this.openErrorPopup(errorMessage);
						return;
					}

					this.downloadBlob(pdfBlob);
				});
			},
			error: error => {
				this.openErrorPopup(
					'Failed to generate PDF: ' + (error.message || 'Unknown error'),
				);
			},
		});
	}

	async verifyPdfBlob(blob: Blob): Promise<boolean> {
		return new Promise(resolve => {
			const reader = new FileReader();
			reader.onload = function (e) {
				const arrayBuffer = e.target?.result as ArrayBuffer;
				const uint8Array = new Uint8Array(arrayBuffer);

				const header = String.fromCharCode(...uint8Array.slice(0, 4));

				if (header === '%PDF') {
					resolve(true);
				} else {
					resolve(false);
				}
			};

			reader.onerror = () => {
				resolve(false);
			};

			reader.readAsArrayBuffer(blob.slice(0, 100));
		});
	}

downloadBlob(blob: Blob) {
	try {
		const url = window.URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.href = url;
		link.download = `invoice_${new Date().toISOString().split('T')[0]}.pdf`;

			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);

			setTimeout(() => {
				window.URL.revokeObjectURL(url);
			}, 1000);
		} catch (error) {
			this.openErrorPopup('Failed to download PDF file');
		}
	}

	getByteArray(file) {
		let sliceSize = 512;

		let byteCharacters = atob(file);
		let byteArrays = [];

		for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
			let slice = byteCharacters.slice(offset, offset + sliceSize);

			let byteNumbers = new Array(slice.length);
			for (let i = 0; i < slice.length; i++) {
				byteNumbers[i] = slice.charCodeAt(i);
			}

			let byteArray = new Uint8Array(byteNumbers);

			byteArrays.push(byteArray);
		}
		return byteArrays;
	}

	validateAndresetToDate(event) {
		this.validateDateFn(event);
		this.filterBy.toDate = null;
	}

	checkDaylight(etaDate) {
		if (momentTimeZone.tz(etaDate, 'America/New_York').isDST()) return 'EDT';
		else return 'EST';
	}

	getStartAndEndOfMonth(year, monthName) {
		const monthNames = [
			'January',
			'February',
			'March',
			'April',
			'May',
			'June',
			'July',
			'August',
			'September',
			'October',
			'November',
			'December',
		];
		const month = monthNames.indexOf(monthName);
		const startOfMonth = new Date(year, month, 1);
		const endOfMonth = new Date(year, month + 1, 0);

		const formatDate = date => {
			let d = new Date(date),
				month = '' + (d.getMonth() + 1),
				day = '' + d.getDate(),
				year = d.getFullYear();

			if (month.length < 2) month = '0' + month;
			if (day.length < 2) day = '0' + day;

			return [year, month, day].join('-');
		};

		const formattedStartOfMonth = formatDate(startOfMonth);
		const formattedEndOfMonth = formatDate(endOfMonth);

		return { start: formattedStartOfMonth, end: formattedEndOfMonth };
	}
}
